class ReadMore extends HTMLElement {
  constructor() {
    super();
    this.content = this.querySelector('[slot="content"]');
    this.button = this.querySelector('[slot="toggle"]');
  }

  connectedCallback() {
    console.log(this.content, this.button);
    if (!this.content || !this.button) return;

    this.checkIfClamped();
    this.button.addEventListener('click', this.toggleContent.bind(this));
    window.addEventListener('resize', this.checkIfClamped.bind(this)); // recheck on resize
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.checkIfClamped.bind(this));
  }

  checkIfClamped() {
    if (!this.content || !this.button) return;

    // Reset style to natural height to compare
    const { scrollHeight, clientHeight } = this.content;
    const isClamped = scrollHeight > clientHeight + 1; // +1 for rounding safety

    this.button.style.display = isClamped ? 'inline-block' : 'none';
  }

  toggleContent() {
    console.log('Toggle Read More');
    if (!this.content || !this.button) return;

    const isExpanded = this.content.dataset.expanded === 'true';
    this.content.dataset.expanded = isExpanded ? 'false' : 'true';
    this.button.setAttribute('aria-expanded', (!isExpanded).toString());
    this.button.classList.toggle('rotate-180', !isExpanded);

    // Hide the button once expanded (optional)
    if (!isExpanded) {
      this.button.style.display = 'none';
    }
  }
}

customElements.define('read-more', ReadMore);